import React from 'react';
import { Link } from 'react-router-dom';

import './AboutJookable.scss';

/**
 * A few plain lines under the sign-in card saying what Jookable is. It is what search
 * engines read on the front page, which otherwise holds only a sign-in form.
 */
const AboutJookable = () => (
  <section className="about-jookable">
    <h2>A jukebox on any TV, picked from any phone</h2>
    <p>
      Jookable turns the TV in your bar, restaurant or party into a music video jukebox. Guests scan the code on the
      screen, search for a song and add it to the queue from their own phone. No coins and no app to install.
    </p>
    <h3>For guests</h3>
    <p>
      Find a venue near you, pick the next song, and use a bump to move it up the line when you can&rsquo;t wait.
    </p>
    <h3>For venues</h3>
    <p>
      Open the player on any TV with a web browser and set your own house rules. Venues earn a share of every paid
      bump, and the control panel lets you skip, remove or reorder songs.
    </p>
    <p className="about-jookable-links">
      <Link to="/signup">Create a free account</Link>
      <span aria-hidden="true"> · </span>
      <Link to="/venues">Venues near you</Link>
    </p>
  </section>
);

export default AboutJookable;
